import { NotificationStrategy, NotificationWorkflowContext } from '../types';

export async function onAccept(
  strategy: NotificationStrategy,
  context: NotificationWorkflowContext,
) {
  return strategy.accept(context);
}
